import { render, staticRenderFns } from "./detailBanner.vue?vue&type=template&id=d2ce5daa&scoped=true&"
import script from "./detailBanner.vue?vue&type=script&lang=js&"
export * from "./detailBanner.vue?vue&type=script&lang=js&"
import style0 from "./detailBanner.vue?vue&type=style&index=0&id=d2ce5daa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ce5daa",
  null
  
)

export default component.exports